import { combineReducers } from "@reduxjs/toolkit";
import amadeusTokenReducer from "../features/amadeusToken/amadeusTokenSlice";
import userDataReducer from "../Slices/User/userDataSlice";
import { amadeusApi } from "../features/amadeusToken/amadeusApi";
import thingsToDoCartReducer from "../Slices/thingsToDoCartSlice";

const rootReducer = () =>
  combineReducers({
    amadeusToken: amadeusTokenReducer,
    userData: userDataReducer, // ← added here
    thingsToDoCart: thingsToDoCartReducer,
    [amadeusApi.reducerPath]: amadeusApi.reducer,
  });

export default rootReducer;
